import { UserType } from '@nemuru-eng/js-api-client';

import { MetricMerchantViewsWrapper } from '@/components/modules/Metrics/MetricMerchantViews/MetricMerchantViewsWrapper';
import { HomeHeader } from '@/components/shared/components/HomeHeader';
import { useUserContext } from '@/contexts/UserContext/UserContext';
import { LEGACY_MERCHANT_IDS } from '@/hooks/useLayoutConstructor';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const MetricsHomeMerchantChannelAgent = () => {
  const { userEntity, structure } = useUserContext();

  if (!userEntity || !structure) return null;

  const merchantId = structure.merchant.id;

  // FIX FOR CREDIT CARD MERCHANTS
  const isCreditCardUser = userEntity?.isCreditCardUser();

  // FIX FOR LEGACY MERCHANT AGENTS
  if (
    userEntity?.hasUserType([UserType.AGENT]) &&
    userEntity.merchant &&
    LEGACY_MERCHANT_IDS.includes(userEntity.merchant.id)
  ) {
    return <HomeHeader username={userEntity.name} />;
  }

  return (
    <div>
      <HomeHeader username={userEntity.name} />
      {!isCreditCardUser && <MetricMerchantViewsWrapper merchantId={merchantId} />}
    </div>
  );
};

export const MetricsHomeMerchantChannelAgentModule = withPermissionsModule(MetricsHomeMerchantChannelAgent);
